import "@/App.css";
import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom";
import { Toaster } from "@/components/ui/sonner";
import { AuthProvider, RequireAuth } from "@/lib/auth";
import Landing from "@/pages/Landing";
import RequestForm from "@/pages/RequestForm";
import RequestSuccess from "@/pages/RequestSuccess";
import Login from "@/pages/Login";
import SupervisorDashboard from "@/pages/SupervisorDashboard";
import AdminDashboard from "@/pages/AdminDashboard";
import PrivacyNotice from "@/pages/legal/PrivacyNotice";
import Terms from "@/pages/legal/Terms";
import SecurityRetention from "@/pages/legal/SecurityRetention";
import Contact from "@/pages/legal/Contact";

function App() {
  return (
    <div className="App">
      <BrowserRouter>
        <AuthProvider>
          <Routes>
            <Route path="/" element={<Landing/>}/>
            <Route path="/request" element={<RequestForm/>}/>
            <Route path="/request/success" element={<RequestSuccess/>}/>
            <Route path="/login" element={<Login/>}/>
            <Route path="/supervisor" element={<RequireAuth><SupervisorDashboard/></RequireAuth>}/>
            <Route path="/supervisors" element={<RequireAuth><SupervisorDashboard/></RequireAuth>}/>
            <Route path="/admin" element={<RequireAuth adminOnly><AdminDashboard/></RequireAuth>}/>
            <Route path="/privacy" element={<PrivacyNotice/>}/>
            <Route path="/terms" element={<Terms/>}/>
            <Route path="/security" element={<SecurityRetention/>}/>
            <Route path="/contact" element={<Contact/>}/>
            <Route path="*" element={<Navigate to="/" replace/>}/>
          </Routes>
          <Toaster richColors position="top-right" theme="dark"/>
        </AuthProvider>
      </BrowserRouter>
    </div>
  );
}

export default App;
